import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimActsKC2VersionOtherGql } from '../../workOrderVersionQueries';

const requestId = 'bimActsKC2VersionOther';

export const useBimActsKC2VersionOther = (
    workOrderVersionId?: number,
    workOrderRootObjectId?: number,
    withEffect = false,
) => {
    const dispatch = useDispatch();
    const [bimActsKC2OtherReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({ workOrderVersionId, workOrderVersionObjectId: workOrderRootObjectId }),
        [workOrderRootObjectId, workOrderVersionId],
    );

    const requestEffect = useMemo(
        () => Boolean(workOrderVersionId) && Boolean(workOrderRootObjectId) && withEffect,
        [withEffect, workOrderVersionId, workOrderRootObjectId],
    );

    const [bimActsKC2OtherData, bimActsKC2OtherStatus, , bimActsKC2OtherRequest] = useRequest({
        requestId,
        query: bimActsKC2VersionOtherGql,
        variables,
        withEffect: requestEffect,
    });

    const isBimPresenceActs = !!bimActsKC2OtherData?.bimActsKC2VersionOther?.items?.length;

    useEffect(() => {
        if (withEffect) {
            bimActsKC2OtherReset(undefined);
        }
    }, [bimActsKC2OtherReset, withEffect]);

    const bimActsKC2OtherMakeRequest = useCallback(() => {
        dispatch(bimActsKC2OtherRequest(variables));
    }, [bimActsKC2OtherRequest, dispatch, variables]);

    return {
        bimActsKC2OtherData,
        bimActsKC2OtherStatus,
        bimActsKC2OtherMakeRequest,
        isBimPresenceActs,
    };
};
